import { Injectable } from '@angular/core';
import { GlobalUtilService } from '@otas/core/services/global-util.service';


@Injectable()
export class IpcUtilService {
    keyboardType;
    constructor(private globalUtilService: GlobalUtilService
) { }

    getKeyBoardType() {
        const currentUser = sessionStorage.getItem('CURRENT_USER');
        if (currentUser) {
            return this.getProperty('Stoda.Default.Keyboard');
        }
        return null;
    }
    setKeyboard(type) {
        this.setProperty('Stoda.Default.Keyboard', type);
    }
    getProperty(property) {
        const d = this.globalUtilService.IPCRendererSend('get:property', property);
        // console.log(d);
        return d;

    }
    setProperty(property, value) {
        const d = this.globalUtilService.IPCRendererSendSync('set:property', property, value);
        // console.log(d);
        return d;

    }
}
